<template>
    <div>   
        <SinMenuConAlertas :nombreAlerta="'ALERTA DE ACTIVIDADES - ' + ubicacion.bloque" :show="true" :showSemaforo="false" :url="'/mapa-bloques/' + ubicacion.sede_id + '/' + ubicacion.municipio_id"  :estaPagina="ubicacion.bloque">
            <template #contenido>
                <UpdateTimeUnidad ref="timeUnidad" />
                <div class="contenedor-info">
                    
                    <div v-if="loader" class="text-center p-5">
                        <Loading :nuevoTitulo="'Cargando Unidades'" />
                    </div>
                    <div v-else>
                        <div class="titulos-ubicacion">
                            <div class="titulo-contenido">
                                <div class="titulos-texto">
                                    <h4 class="titulo-sede">{{ ubicacion.sede }}</h4>    
                                    <h6 class="titulo-bloque">{{ ubicacion.bloque }}</h6>
                                </div>
                                <div class="boton-descarga-contenedor">
                                    <b-button
                                        variant="outline-light"
                                        size="sm"
                                        @click="descargarLecturasBloque"
                                        :disabled="loaderDescarga"
                                        class="btn-descarga-bloque"
                                        title="Descargar todas las lecturas del bloque en CSV"
                                    >
                                        <b-spinner v-if="loaderDescarga" small class="mr-2"></b-spinner>
                                        <i v-else class="fas fa-download mr-2"></i>
                                        {{ loaderDescarga ? 'Descargando...' : 'Descargar CSV' }}
                                    </b-button>
                                </div>
                            </div>
                        </div>    
                        <!-- Campo de búsqueda -->
                        <div class="buscador-container">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                                <b-form-input
                                    v-model="busqueda"
                                    placeholder="Buscar por CBI o Ubicación..."
                                    class="form-control-busqueda"
                                    size="sm"
                                ></b-form-input>
                                <div class="input-group-append" v-if="busqueda">
                                    <button class="btn btn-outline-secondary btn-limpiar" type="button" @click="busqueda = ''">
                                        <i class="fas fa-times"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="resultados-busqueda" v-if="busqueda">
                                <small class="text-muted">
                                    Mostrando {{ unidadesParaMostrar.length }} de {{ totalUnidades }} unidades
                                </small>
                            </div>
                        </div>

                        <div class="tabla-con-controles">
                            <b-card class="tabla-unidadesConAlertas-card">
                                <div class="table-responsive tabla-scrollable">
                                    <b-table
                                        :items="unidadesParaMostrar"
                                        :fields="fields"
                                        striped hover small responsive
                                        :bordered="false"
                                        
                                        :sort-desc="false"
                                        class="tabla-unidadesConAlertas-custom"
                                        thead-class="tabla-header"
                                        tbody-class="tabla-body"
                                        :tbody-tr-class="rowClass"
                                    >
                                        <template #cell(numero)="data">
                                            <span class="numero-fila">{{ data.index + 1 }}</span>
                                        </template>
                                        <template #cell(estado)="data">
                                            <span class="badge border border-light rounded-circle p-2 bg-secondary" v-if="data.item.tiempo.tiene_lecturas === 0">
                                                <span class="visually-hidden">No. alertas</span>
                                            </span>
                                            <span class="badge border border-light rounded-circle p-2" :class="{'bg-success' : data.item.alertas.length === 0, 'bg1' : data.item.alertas.length === 1, 'bg2' : data.item.alertas.length === 2, 'bg-danger' : data.item.alertas.length >= 3 || (data.item.alerta_actividad && data.item.alerta_actividad.detallealerta_id === 7)}" v-else>
                                                <span class="visually-hidden">No. alertas</span>
                                            </span>
                                        </template>
                                        <template #cell(capacidad)="data">
                                            <div class="capacidad-text">
                                                {{ formatearNumero(data.item.capacidad.capacidad) }} BTU
                                            </div>
                                        </template>
                                        <template #cell(area_especifica)="data">
                                            <div class="ubicacion-text" :title="data.item.area_especifica">
                                                {{ data.item.area_especifica }}
                                            </div>
                                        </template>
                                        <template #cell(piso)="data">
                                            <div class="piso-text" :title="data.item.piso.piso">
                                                {{ data.item.piso.piso.replace(' ', '\n') }}
                                            </div>
                                        </template>
                                        <template #cell(tipo_equipo)="data">
                                            <div class="tipo-equipo-text" :title="data.item.tipo.tipo_equipo">
                                                {{ data.item.tipo.tipo_equipo.replace(' ', '\n') }}
                                            </div>
                                        </template>
                                        <template #cell(acciones)="data">
                                            <div class="acciones-container">
                                                <b-icon icon="info-circle" @click="verUnidad(data.item.id)" title="Ver detalle de la unidad" class="boton ver"></b-icon>
                                                <b-icon icon="pencil-square" @click="editarUnidad(data.item)" title="Editar informacion de la unidad" class="boton editar"></b-icon>
                                                <!-- Botones para unidades activas (estado != 2) -->
                                                <template v-if="data.item.estado_id !== 2">
                                                    <b-icon icon="arrow-down-circle" @click="darBajaUnidad(data.item.id)" title="Dar de baja la unidad" class="boton dar-baja"></b-icon>
                                                </template>
                                                <!-- Botones para unidades dadas de baja (estado == 2) -->
                                                <template v-else>
                                                    <b-icon icon="trash" @click="eliminarUnidad(data.item)" title="Eliminar permanentemente la unidad" class="boton eliminar"></b-icon>
                                                    <b-icon icon="arrow-up-circle" @click="habilitarUnidad(data.item)" title="Habilitar la unidad" class="boton habilitar"></b-icon>
                                                </template>
                                            </div>
                                        </template>
                                    </b-table>
                                </div>
                            </b-card>
                            
                            <div class="controles-inferiores">
                                <div class="boton-agregar">
                                    <a-button type="primary" shape="circle" icon="plus" @click="crearUnidad" />
                                </div>
                                <div class="conteo-registros">
                                    <span class="texto-conteo">
                                        Total: {{ busqueda ? unidadesParaMostrar.length + ' de ' + totalUnidades : totalUnidades }} unidades
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </SinMenuConAlertas> 
    </div>
</template>

<script>
    import axios from 'axios';
    import SinMenuConAlertas from '@/layouts/SinMenuConAlertas.vue';
    import UpdateTimeUnidad from '@/components/Unidades/UpdateTimeUnidad.vue';
    import Swal from 'sweetalert2';
    import Loading from '@/components/Loader/Loading.vue';

    export default {
        components: {
            SinMenuConAlertas, UpdateTimeUnidad, Loading
        },
        data(){
            return{
                loader: true,
                loaderDescarga: false, // Loader para descarga de CSV
                loaderEliminar: false, // Loader para eliminar unidad
                intervalId: null,
                ubicacion: {id: null, sede: null, bloque: null},
                unidades: [],
                busqueda: '',
                totalUnidades: 0,
                fields: [
                    { key: 'numero', label: '#', class: 'text-center', sortable: false },
                    { key: 'cbi', label: 'CBI', sortable: true },
                    { key: 'area_especifica', label: 'Ubicación', sortable: true },
                    { 
                        key: 'piso', 
                        label: 'Piso', 
                        sortable: true,
                        sortByFormatted: false,
                        sortKey: 'id'
                    },
                    { key: 'tipo_equipo', label: 'Tipo equipo', sortable: true },
                    { key: 'marca', label: 'Marca', sortable: true },
                    { key: 'capacidad', label: 'Capacidad', sortable: true },
                    { key: 'tiempo.estado_equipo', label: 'ON/OFF', sortable: true },
                    { key: 'estado', label: 'Estado', class: 'text-center', sortable: false },
                    { key: 'acciones', label: '', sortable: false },
                ]
            }
        },
        computed: {
            unidadesParaMostrar() {
                if (!this.busqueda.trim()) {
                    return this.unidades;
                }
                
                const busquedaLower = this.busqueda.toLowerCase().trim();
                return this.unidades.filter(unidad => {
                    const cbi = (unidad.cbi || '').toLowerCase();
                    const ubicacion = (unidad.area_especifica || '').toLowerCase();
                    return cbi.includes(busquedaLower) || ubicacion.includes(busquedaLower);
                });
            }
        },
        async mounted() {
            this.$store.commit('deleteNumeroAlertas');
            
            await this.getBloque(this.$route.params.id);
            await this.getUnidades();
            
            this.intervalId = setInterval(this.getUnidades, 60000);
        },
        beforeDestroy() {
            clearInterval(this.intervalId);
            this.intervalId = null;
        },

        methods: {
            rowClass(item, type) {
                if (!item || type !== 'row') return '';
                // console.log('rowClass - item:', item, 'estado_id:', item.estado_id, 'type:', type);
                if (item.estado_id === 2) return 'row-danger';
                return '';
            },
            formatearNumero(numero) {
                if (numero == null || numero === '') return numero;
                return Number(numero).toLocaleString('es-CO');
            },
            actualizarTiempoUnidad(unidad){
                this.$refs.timeUnidad.verModal(unidad);
            },
            crearUnidad(){
                this.$router.push({ name: 'CrearUnidad', params: { sede_id: this.ubicacion.sede_id, bloque_id: this.ubicacion.bloque_id } })
            },
            darBajaUnidad(id){
                Swal.fire({
                    title: '¿Estás seguro?',
                    text: "Esta acción cambiará el estado de la unidad a 'BAJA'.",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sí, dar de baja',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.put(`/api/unidad/${id}/dar_baja`, { estado: 'BAJA' }, {
                            headers: { "Authorization": `Bearer ${this.$store.state.user.token}` }
                        })
                        .then(res => {
                            Swal.fire({
                                icon: 'success',
                                title: '¡Dado de baja!',
                                text: `La unidad ha sido dada de baja.`,
                                timer: 3000,
                                showConfirmButton: false
                            });
                            this.getUnidades();
                        })
                        .catch(err => {
                            Swal.fire('Error', 'Hubo un problema al dar de baja la unidad.', 'error');
                        });
                    }
                });
            },
            eliminarUnidad(item){
                Swal.fire({
                    title: '⚠️ ELIMINAR UNIDAD PERMANENTEMENTE',
                    html: `
                        <div style="text-align: left; margin: 15px 0;">
                            <p><strong>¿Estás seguro de que deseas eliminar la unidad ${item.cbi}?</strong></p>
                            <div style="background: #fff3cd; border: 1px solid #ffeaa7; border-radius: 5px; padding: 10px; margin: 10px 0;">
                                <p style="margin: 0; color: #856404;"><strong>⚠️ ADVERTENCIA:</strong></p>
                                <ul style="margin: 5px 0; padding-left: 20px; color: #856404;">
                                    <li>Se eliminarán TODAS las alertas almacenadas de esta unidad</li>
                                    <li>Se eliminarán los tiempos de operación de la unidad</li>
                                    <li>Las lecturas de la unidad permanecerán en el sistema</li>
                                </ul>
                            </div>
                            <p style="color: #dc3545; font-weight: bold;">Esta acción NO se puede deshacer.</p>
                        </div>
                    `,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#dc3545',
                    cancelButtonColor: '#6c757d',
                    confirmButtonText: 'Sí, eliminar permanentemente',
                    cancelButtonText: 'Cancelar',
                    customClass: {
                        popup: 'swal-wide'
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        // Mostrar loader durante la eliminación
                        this.loaderEliminar = true;
                        
                        // Mostrar modal de progreso
                        Swal.fire({
                            title: '🗑️ Eliminando unidad...',
                            html: `
                                <div style="text-align: center; margin: 20px 0;">
                                    <div class="swal2-loader" style="border-color: #dc3545 transparent #dc3545 transparent;"></div>
                                    <p style="margin-top: 15px; color: #666;">Eliminando la unidad ${item.cbi}</p>
                                    <p style="font-size: 0.9em; color: #999;">Por favor espere...</p>
                                </div>
                            `,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showConfirmButton: false,
                            didOpen: () => {
                                Swal.showLoading();
                            }
                        });
                        
                        axios.delete(`/api/eliminar-unidad/${item.cbi}`, {
                            headers: { "Authorization": `Bearer ${this.$store.state.user.token}` }
                        })
                        .then(res => {
                            Swal.fire({
                                icon: 'success',
                                title: '¡Unidad eliminada!',
                                text: `La unidad ${item.cbi} ha sido eliminada permanentemente.`,
                                timer: 3000,
                                showConfirmButton: false
                            });
                            this.getUnidades();
                        })
                        .catch(err => {
                            console.error('Error eliminando unidad:', err);
                            let mensaje = 'Hubo un problema al eliminar la unidad.';
                            if (err.response?.data?.message) {
                                mensaje = err.response.data.message;
                            }
                            Swal.fire('Error', mensaje, 'error');
                        })
                        .finally(() => {
                            this.loaderEliminar = false;
                        });
                    }
                });
            },
            habilitarUnidad(item){
                Swal.fire({
                    title: '¿Habilitar unidad?',
                    text: `¿Estás seguro de que deseas habilitar la unidad ${item.cbi}?`,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#28a745',
                    cancelButtonColor: '#6c757d',
                    confirmButtonText: 'Sí, habilitar',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.put(`/api/unidad/${item.id}/habilitar-unidad`, {
                            headers: { "Authorization": `Bearer ${this.$store.state.user.token}` }
                        })
                        .then(res => {
                            Swal.fire({
                                icon: 'success',
                                title: '¡Unidad habilitada!',
                                text: `La unidad ${item.cbi} ha sido habilitada correctamente.`,
                                timer: 3000,
                                showConfirmButton: false
                            });
                            this.getUnidades();
                        })
                        .catch(err => {
                            console.error('Error habilitando unidad:', err);
                            let mensaje = 'Hubo un problema al habilitar la unidad.';
                            if (err.response?.data?.message) {
                                mensaje = err.response.data.message;
                            }
                            Swal.fire('Error', mensaje, 'error');
                        });
                    }
                });
            },
            editarUnidad(item){
                this.$router.push({name: 'EditarUnidad', params: {sede_id: this.ubicacion.sede_id, bloque_id: this.ubicacion.bloque_id, id: item.id}})
            },
            getAlertas(){
                const data = { municipio: 0, sede: 0, bloque: this.$route.params.id, cbi: 0 };
                this.$store.dispatch('getAlertasActividad', data);
            },
            async getBloque(id){
                try {
                    const res = await axios.get(`/api/bloque/${id}`, {
                        headers: { "Authorization": `Bearer ${this.$store.state.user.token}` }
                    });
                    document.title = res.data.bloque_edificio;
                    this.ubicacion = {
                        bloque_id: res.data.id, sede_id: res.data.sede_id, sede: res.data.sede.nombre, bloque: res.data.bloque_edificio, municipio_id: res.data.sede.municipio_id
                    };
                } catch (err) {
                    console.error("Error obteniendo el bloque:", err);
                }
            },
            async getUnidades(){
                try {
                    const res = await axios.get(`/api/unidades_bloque/${this.$route.params.id}`, {
                        headers: { "Authorization": `Bearer ${this.$store.state.user.token}` }
                    });
                    // console.log("Respuesta unidades:", res.data);
                    this.unidades = res.data.unidades || res.data || [];
                    this.totalUnidades = this.unidades.length;
                    this.getAlertas();
                } catch (err) {
                    console.error("Error obteniendo las unidades:", err);
                    this.unidades = [];
                    this.totalUnidades = 0;
                } finally {
                    this.loader = false;
                }
            },
            verUnidad(id){
                this.$router.push({name: 'VerUnidad', params: {id: id}})
            },
            
            async descargarLecturasBloque() {
                // Mostrar confirmación antes de iniciar la descarga
                let confirmacion;
                if (window.Swal) {
                    confirmacion = await Swal.fire({
                        icon: 'warning',
                        title: '⚠️ Descarga de Datos Masivos',
                        html: `
                            <div style="text-align: left; margin: 20px 0;">
                                <p><strong>Esta operación puede tomar varios minutos debido a:</strong></p>
                                <ul style="margin: 10px 0; padding-left: 20px;">
                                    <li>Gran volumen de datos del bloque</li>
                                    <li>Procesamiento de todos los registros históricos</li>
                                    <li>Generación del archivo CSV completo</li>
                                </ul>
                                <div style="background: #f8f9fa; padding: 15px; border-radius: 8px; margin: 15px 0; border-left: 4px solid #17a2b8;">
                                    <strong>💡 Recomendación:</strong> No cierre esta ventana durante el proceso
                                </div>
                            </div>
                        `,
                        showCancelButton: true,
                        confirmButtonText: 'Sí, continuar descarga',
                        cancelButtonText: 'Cancelar',
                        confirmButtonColor: '#28a745',
                        cancelButtonColor: '#6c757d',
                        reverseButtons: true
                    });
                } else {
                    confirmacion = { 
                        isConfirmed: confirm('Esta descarga puede tomar varios minutos debido al gran volumen de datos.\n\n¿Desea continuar?') 
                    };
                }
                
                if (!confirmacion.isConfirmed) {
                    return; // Usuario canceló la operación
                }
                
                this.loaderDescarga = true;
                
                // Mostrar ventana de progreso
                let progressModal;
                if (window.Swal) {
                    progressModal = Swal.fire({
                        title: '📊 Generando archivo CSV',
                        html: `
                            <div style="text-align: left; margin: 20px 0;">
                                <div id="progress-step" style="margin: 15px 0; font-weight: 600; color: #495057;">
                                    🔄 Conectando con el servidor...
                                </div>
                                <div style="background: #f8f9fa; border-radius: 10px; padding: 3px; margin: 15px 0;">
                                    <div id="progress-bar" style="
                                        width: 10%;
                                        height: 25px;
                                        background: linear-gradient(45deg, #28a745, #20c997);
                                        border-radius: 8px;
                                        transition: all 0.3s ease;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        color: white;
                                        font-weight: bold;
                                        font-size: 12px;
                                    ">10%</div>
                                </div>
                                <div style="font-size: 0.9rem; color: #6c757d; text-align: center;">
                                    Por favor no cierre esta ventana
                                </div>
                            </div>
                        `,
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        showConfirmButton: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });
                }
                
                const updateProgress = (step, percentage, message) => {
                    if (window.Swal && document.getElementById('progress-step')) {
                        document.getElementById('progress-step').innerHTML = message;
                        const progressBar = document.getElementById('progress-bar');
                        if (progressBar) {
                            progressBar.style.width = percentage + '%';
                            progressBar.innerHTML = percentage + '%';
                        }
                    }
                };
                
                try {
                    
                    // Actualizar progreso: Obteniendo datos
                    updateProgress(1, 25, '📡 Obteniendo datos del servidor...');
                    
                    // Solicitar descarga con parámetro para optimización
                    const response = await axios.get(`/api/lecturas-por-bloque/${this.ubicacion.bloque_id}?optimized=true&chunk_size=1000`, {
                        headers: { Authorization: `Bearer ${this.$store.state.user.token}` },
                        timeout: 300000 // 5 minutos de timeout
                    });
                    
                    // Actualizar progreso: Datos recibidos
                    updateProgress(2, 45, '✅ Datos recibidos, procesando...');
                    
                    let datos = [];
                    
                    // Extraer datos de la respuesta
                    if (response.data && Array.isArray(response.data)) {
                        datos = response.data;
                    } else if (response.data.data && Array.isArray(response.data.data)) {
                        datos = response.data.data;
                    } else if (response.data.lecturas) {
                        datos = response.data.lecturas;
                    }
                    
                    if (datos.length === 0) {
                        if (window.Swal) {
                            Swal.fire({
                                icon: 'warning',
                                title: 'Sin datos',
                                text: 'No hay lecturas disponibles para este bloque'
                            });
                        } else {
                            alert('No hay lecturas disponibles para este bloque');
                        }
                        return;
                    }
                    
                    // Actualizar progreso: Preparando CSV
                    updateProgress(3, 65, '🔧 Preparando estructura del archivo CSV...');
                    
                    // Preparar encabezados CSV con todos los campos
                    const encabezados = [
                        'Sede',
                        'Bloque',
                        'Área Específica',
                        'CBI',
                        'Estado',
                        // 'Timestamp',
                        'Fecha',
                        'Hora',
                        'Voltaje Exterior (V)',
                        'Corriente Exterior (A)',
                        'Potencia Exterior (W)',
                        'Factor Potencia Exterior',
                        'Frecuencia Exterior (Hz)',
                        'Voltaje Interior (V)',
                        'Corriente Interior (A)',
                        'Potencia Interior (W)',
                        'Factor Potencia Interior',
                        'Frecuencia Interior (Hz)',
                        'Temp. DS18B20 (°C)',
                        'Temp. Ambiente (°C)',
                        'Humedad Ambiente (%)',
                        'Potencia Total (W)',
                        'Energía Total (Wh)',
                        'Tiempo On (segundos)'
                    ];
                    
                    // Convertir datos a filas CSV
                    const filasCsv = datos.map((item, index) => [
                        item.sede || this.ubicacion.sede || '',
                        item.bloque || this.ubicacion.bloque || '',
                        item.area_especifica || '',
                        item.cbi || '',
                        item.estado || '',
                        // item.timestamp || '',
                        this.formatFechaColombia(item.timestamp),
                        this.formatHoraColombia(item.timestamp),
                        item.voltaje_exterior || '',
                        item.corriente_exterior || '',
                        item.potencia_exterior || '',
                        item.fp_exterior || '',
                        item.frecuencia_exterior || '',
                        item.voltaje_interior || '',
                        item.corriente_interior || '',
                        item.potencia_interior || '',
                        item.fp_interior || '',
                        item.frecuencia_interior || '',
                        item.temperatura_ds18b20 || '',
                        item.temperatura_ambiente || '',
                        item.humedad_ambiente || '',
                        item.potencia_total || '',
                        item.energia_total || '',
                        item.tiempo_on || ''
                    ]);
                    
                    // Actualizar progreso: Generando contenido
                    updateProgress(4, 80, '📝 Generando contenido del archivo...');
                    
                    // Crear contenido CSV con BOM para UTF-8
                    const BOM = '\uFEFF'; // BOM para UTF-8
                    let csvContent = BOM + encabezados.join(',') + '\n';
                    filasCsv.forEach(fila => {
                        csvContent += fila.map(campo => {
                            // Convertir a string y manejar valores nulos
                            let valor = campo === null || campo === undefined ? '' : String(campo);
                            
                            // Escapar campos que contengan comas, comillas o caracteres especiales
                            if (valor.includes(',') || valor.includes('"') || valor.includes('\n') || valor.includes('\r')) {
                                return `"${valor.replace(/"/g, '""')}"`;
                            }
                            return valor;
                        }).join(',') + '\n';
                    });
                    
                    // Generar nombre de archivo
                    const fechaActual = new Date().toISOString().split('T')[0];
                    const nombreArchivo = `Lecturas_Bloque_${this.ubicacion.bloque.replace(/[^a-zA-Z0-9áéíóúñÁÉÍÓÚÑ]/g, '_')}_${fechaActual}.csv`;
                    
                    // Actualizar progreso: Finalizando descarga
                    updateProgress(5, 95, '💾 Preparando descarga del archivo...');
                    
                    // Pequeña pausa para mostrar el progreso
                    await new Promise(resolve => setTimeout(resolve, 500));
                    
                    // Crear y descargar archivo CSV con codificación UTF-8
                    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
                    const link = document.createElement('a');
                    const url = URL.createObjectURL(blob);
                    link.setAttribute('href', url);
                    link.setAttribute('download', nombreArchivo);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    
                    // Actualizar progreso: Completado
                    updateProgress(6, 100, '🎉 ¡Descarga completada exitosamente!');
                    
                    // Pequeña pausa antes de cerrar
                    await new Promise(resolve => setTimeout(resolve, 1000));
                    
                    // Mostrar mensaje de éxito y cerrar modal de progreso
                    if (window.Swal) {
                        Swal.fire({
                            icon: 'success',
                            title: '¡Descarga completada!',
                            text: `Archivo ${nombreArchivo} descargado correctamente (${datos.length} registros)`,
                            timer: 3000,
                            showConfirmButton: false
                        });
                    } else {
                        alert(`Éxito: Archivo ${nombreArchivo} descargado correctamente (${datos.length} registros)`);
                    }
                    
                } catch (error) {
                    console.error('Error descargando lecturas del bloque:', error);
                    
                    // Cerrar modal de progreso si hay error
                    if (window.Swal) {
                        Swal.close();
                    }
                    
                    let mensajeError = 'Error al descargar las lecturas del bloque';
                    let sugerencia = '';
                    
                    if (error.response) {
                        if (error.response.status === 404) {
                            mensajeError = 'No se encontraron lecturas para este bloque';
                        } else if (error.response.status === 500) {
                            // Verificar si es error de memoria
                            const errorMsg = error.response.data?.message || error.message || '';
                            if (errorMsg.includes('memory') || errorMsg.includes('memoria') || errorMsg.includes('Allowed memory size')) {
                                mensajeError = 'El bloque tiene demasiados datos para descargar de una vez';
                                sugerencia = 'Contacte al administrador del sistema para optimizar la consulta o solicitar los datos por fechas específicas.';
                            } else {
                                mensajeError = 'Error interno del servidor al obtener los datos';
                                sugerencia = 'Intente nuevamente en unos minutos.';
                            }
                        } else if (error.response.status === 408 || error.code === 'ECONNABORTED') {
                            mensajeError = 'La consulta está tomando demasiado tiempo';
                            sugerencia = 'El bloque tiene muchos datos. Contacte al administrador para optimizar la descarga.';
                        } else {
                            mensajeError = `Error HTTP ${error.response.status}: ${error.response.data?.message || error.message}`;
                        }
                    } else if (error.code === 'ECONNABORTED') {
                        mensajeError = 'Tiempo de espera agotado - La consulta es muy grande';
                        sugerencia = 'Contacte al administrador del sistema para solicitar los datos por rangos de fechas.';
                    } else {
                        mensajeError = `Error: ${error.message}`;
                    }
                    
                    if (window.Swal) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error en la descarga',
                            html: `<p><strong>${mensajeError}</strong></p>${sugerencia ? `<p style="margin-top: 10px; font-size: 0.9em; color: #666;"><em>${sugerencia}</em></p>` : ''}`,
                            confirmButtonText: 'Entendido'
                        });
                    } else {
                        alert(`Error: ${mensajeError}${sugerencia ? `\n\n${sugerencia}` : ''}`);
                    }
                } finally {
                    this.loaderDescarga = false;
                }
            },
            
            formatFechaColombia(ts) {
                if (!ts) return '';
                const fecha = new Date(ts);
                return fecha.toLocaleDateString('es-CO', { timeZone: 'America/Bogota' });
            },
            
            formatHoraColombia(ts) {
                if (!ts) return '';
                const fecha = new Date(ts);
                return fecha.toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, timeZone: 'America/Bogota' });
            }
        },
    }
</script>

<style scoped>
    .tabla-con-controles {
        display: flex;
        flex-direction: column;
        gap: 0.5rem; /* ✅ Reducido de 1rem a 0.5rem */
        flex: 1;
        min-height: 0;
        overflow: hidden;
        width: 100%;
        box-sizing: border-box;
        padding: 0; /* ✅ Sin padding adicional para evitar desbordamiento */
    }

    .controles-inferiores {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.5rem 1rem; /* ✅ Reducido de 1rem a 0.5rem vertical */
        background: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #dee2e6;
        flex-shrink: 0;
    }

    .bg2{
        background-color: #ffc107 !important;
    }

    .boton-agregar .ant-btn {
        width: 42px !important; /* ✅ Reducido de 50px a 42px */
        height: 42px !important; /* ✅ Reducido de 50px a 42px */
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3) !important;
        border: none !important;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
        background-color: #4a5568 !important;
    }

    .boton-agregar .ant-btn:hover {
        transform: translateY(-2px) !important;
        box-shadow: 0 6px 16px rgba(24, 144, 255, 0.4) !important;
        background-color: r#4a5568 !important;
        border-color: #4a5568 !important;
    }

    .boton-agregar .ant-btn:active {
        transform: translateY(0);
        box-shadow: 0 4px 12px rgba(24, 144, 255, 0.35);
    }

    .paginacion-wrapper {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.25rem; /* ✅ Reducido de 0.5rem a 0.25rem */
    }

    .conteo-registros {
        order: 1;
    }

    .custom-pagination {
        order: 2;
        margin: 0; /* ✅ Asegurar que no hay márgenes */
    }

    .texto-conteo {
        font-size: 0.8rem; /* ✅ Reducido de 0.875rem a 0.8rem */
        color: #6c757d;
        font-weight: 500;
    }

    .anticon-plus{
        font-size: 22px !important; /* ✅ Reducido de 28px a 22px */
        color: white !important;
        font-weight: bold !important;
    }

    /* Selector más específico para el ícono del botón */
    .boton-agregar .ant-btn .anticon-plus {
        font-size: 22px !important; /* ✅ Reducido de 28px a 22px */
        color: white !important;
        font-weight: bold !important;
    }

    /* Selector alternativo para el ícono */
    .boton-agregar .ant-btn >>> .anticon-plus {
        font-size: 22px !important; /* ✅ Reducido de 28px a 22px */
        color: white !important;
        font-weight: bold !important;
    }
    
    .tabla-full-width {
        width: 100%;
        margin: 0;
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        overflow: hidden;
        position: relative; /* ✅ Para el overlay del loader */
        box-sizing: border-box;
        max-width: 100%; /* ✅ No exceder el contenedor padre */
    }

    /* ✅ Estilos para el loader de paginación */
    .loader-paginacion-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(2px);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10;
        border-radius: 8px;
    }

    .loader-paginacion-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
        padding: 2rem;
        background: white;
        border-radius: 12px;
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        border: 1px solid #e9ecef;
    }

    .loader-texto {
        color: #4a5568;
        font-size: 0.9rem;
        font-weight: 500;
        margin-top: 0.5rem;
    }

    /* ✅ Efecto blur en la tabla durante la carga */
    .loading-blur {
        filter: blur(1px);
        opacity: 0.7;
        pointer-events: none;
        transition: all 0.3s ease;
    }

    /* ✅ Responsive para el loader de paginación */
    @media (max-width: 768px) {
        .loader-paginacion-content {
            padding: 1.5rem;
            gap: 0.75rem;
        }

        .loader-texto {
            font-size: 0.85rem;
        }
    }

    @media (max-width: 480px) {
        .loader-paginacion-content {
            padding: 1rem;
            gap: 0.5rem;
        }

        .loader-texto {
            font-size: 0.8rem;
        }
    }

    .tabla-full-width .table-responsive {
        flex: 1;
        overflow-y: auto;
        overflow-x: auto; /* ✅ Scroll horizontal controlado */
        min-height: 0;
        max-height: 100%;
        /* ✅ Asegurar que el scroll funcione con el mouse */
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: contain;
        /* ✅ Eliminar padding y margin que puedan interferir */
        padding: 0 !important;
        margin: 0 !important;
        /* ✅ Contener el contenido dentro del contenedor */
        height: 100%;
        width: 100%;
        box-sizing: border-box;
    }
    
    .boton{
        cursor: pointer;
        margin-right: 1px;
        font-size: 14pt;
        transition: all 0.2s ease;
    }
    .boton:hover {
        transform: scale(1.1);
    }
    .ver{ color: #28a745; }
    .editar{ color: #fd7e14; }
    .eliminar{ color: #dc3545; }
    .dar-baja{ color: #6c757d; }
    .habilitar{ color: #28a745; }

    .tabla-unidadesConAlertas-card {
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        border: none;
        border-radius: 8px;
        overflow: hidden;
        width: 100%;
        max-width: 100%;
        display: flex;
        flex-direction: column;
        min-height: 0;
        box-sizing: border-box; /* ✅ Incluir border en el cálculo del ancho */
    }

    .tabla-unidadesConAlertas-card .card-body {
        flex: 1;
        min-height: 0;
        overflow: hidden;
        padding: 0 !important; /* ✅ Forzar padding 0 */
        margin: 0 !important; /* ✅ Eliminar cualquier margen */
        display: flex;
        flex-direction: column;
    }
    
    /* ✅ Usar ::v-deep para que los estilos lleguen a los componentes hijos */
    .tabla-unidadesConAlertas-custom >>> .table-responsive {
        margin: 0;
    }

    .tabla-unidadesConAlertas-custom >>> th {
        background-color: #4a5568 !important;
        color: white !important;
        font-weight: 600;
        text-transform: uppercase;
        font-size: 0.7rem; /* ✅ Fuente muy pequeña para headers */
        letter-spacing: 0.025em;
        padding: 0.5rem 0.3rem; /* ✅ Padding mínimo */
        border: none;
        border-bottom: 2px solid #2d3748;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        box-sizing: border-box;
    }
    .tabla-unidadesConAlertas-custom >>> thead th:first-child { border-top-left-radius: 8px; }
    .tabla-unidadesConAlertas-custom >>> thead th:last-child { border-top-right-radius: 8px; }
    
    .tabla-unidadesConAlertas-custom >>> tbody tr {
        background-color: #f8f9fa;
        transition: background-color 0.15s ease;
    }
    .tabla-unidadesConAlertas-custom >>> tbody tr:nth-child(even) { background-color: #e9ecef; }
    .tabla-unidadesConAlertas-custom >>> tbody tr:hover { background-color: #dee2e6 !important; }
    
    .tabla-unidadesConAlertas-custom >>> td {
        /* ✅ Padding mínimo para máxima compacidad */
        padding: 0.2rem 0.3rem;
        border: none;
        border-bottom: 1px solid #dee2e6;
        color: #495057;
        font-size: 0.8rem; /* ✅ Fuente aún más pequeña */
        vertical-align: middle;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100px; /* ✅ Ancho máximo más restrictivo */
        box-sizing: border-box;
    }

    .acciones-container {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 0.2rem;
        justify-content: center;
        width: 120px; /* ✅ Ancho ampliado para más acciones */
        min-height: 35px; /* ✅ Altura mínima para evitar salto de contenido */
    }

    /* ✅ CRITICAL: Forzar que la tabla no exceda el contenedor */
    .table-responsive {
        width: 100% !important;
        max-width: 100% !important;
        overflow-x: auto !important;
        box-sizing: border-box !important;
        margin: 0 !important;
        padding: 0 !important;
    }

    /* ✅ Card de tabla sin padding extra */
    .tabla-unidadesConAlertas-card {
        border: none !important;
        box-shadow: none !important;
        margin: 0 !important;
        padding: 0 !important;
        width: 100% !important;
        max-width: 100% !important;
        overflow: hidden !important;
    }

    /* ✅ Mejorar legibilidad del texto en celdas */
    .tabla-unidadesConAlertas-custom td {
        white-space: normal !important;
        word-wrap: break-word !important;
        word-break: break-word !important;
        overflow-wrap: break-word !important;
        line-height: 1.2 !important;
    }

    /* ✅ Estilos para encabezados ordenables */
    .tabla-unidadesConAlertas-custom th[aria-sort] {
        cursor: pointer !important;
        user-select: none !important;
        position: relative !important;
    }

    .tabla-unidadesConAlertas-custom th[aria-sort]:hover {
        background-color: rgba(0,0,0,0.1) !important;
    }

    .tabla-unidadesConAlertas-custom th[aria-sort]::after {
        content: '\2195' !important;
        position: absolute !important;
        right: 8px !important;
        opacity: 0.5 !important;
        font-size: 0.8em !important;
    }

    .tabla-unidadesConAlertas-custom th[aria-sort='ascending']::after {
        content: '\2191' !important;
        opacity: 1 !important;
    }

    .tabla-unidadesConAlertas-custom th[aria-sort='descending']::after {
        content: '\2193' !important;
        opacity: 1 !important;
    }

    .tabla-unidadesConAlertas-card .card-body {
        padding: 0.25rem !important;
        margin: 0 !important;
        width: 100% !important;
        max-width: 100% !important;
        overflow-x: auto !important;
        box-sizing: border-box !important;
    }

    /* ✅ Estilos específicos para texto en celdas */
    .ubicacion-text,
    .capacidad-text {
        word-wrap: break-word !important;
        overflow-wrap: break-word !important;
        word-break: break-word !important;
        hyphens: auto !important;
        line-height: 1.3 !important;
        max-width: 100% !important;
        white-space: normal !important;
    }

    .ubicacion-text {
        font-size: 0.8rem !important;
        max-width: 180px !important;
    }

    .capacidad-text {
        font-size: 0.8rem !important;
        font-weight: 500 !important;
        white-space: nowrap !important;
    }

    /* ✅ Estilos para campos con salto de línea */
    .piso-text,
    .tipo-equipo-text {
        font-size: 0.7rem !important;
        line-height: 1.1 !important;
        white-space: pre-line !important;
        text-align: center !important;
        word-wrap: break-word !important;
        vertical-align: middle !important;
    }

    /* ✅ Estilos específicos para columna PISO */
    .tabla-unidadesConAlertas-custom th:nth-child(4),
    .tabla-unidadesConAlertas-custom td:nth-child(4) {
        font-size: 0.75rem !important;
        line-height: 1.2 !important;
        word-wrap: break-word !important;
        overflow-wrap: break-word !important;
    }

    /* ✅ Asegurar que el contenedor principal no se desborde */
    .contenedor-info {
        overflow-x: hidden !important;
    }

    /* ✅ Contenedor del card completo */
    .tabla-unidadesConAlertas-card.card {
        max-width: 100% !important;
        width: 100% !important;
        overflow-x: hidden !important;
        box-sizing: border-box !important;
        margin: 0 !important;
        padding: 0 !important;
        border: none !important;
    }

    .tabla-unidadesConAlertas-card .card-body {
        padding: 0.5rem !important;
        margin: 0 !important;
        overflow-x: hidden !important;
    }

    /* ✅ Contenedor específico para evitar desbordamiento global */
    .container-fluid,
    .row,
    .col-12 {
        max-width: 100% !important;
        overflow-x: hidden !important;
        box-sizing: border-box !important;
    }

    /* ✅ CRITICAL: Anular padding del layout padre y agregar márgenes */
    .contenedor-info {
        margin: 0 0.5rem !important;
        padding: 1rem 1rem 0.5rem 1rem !important;
        width: calc(100% - 1rem) !important;
        max-width: calc(100vw - 1rem) !important;
        box-sizing: border-box !important;
    }

    /* ✅ Contener titulos dentro del viewport */
    .titulos-ubicacion {
        margin: 0 0 1rem 0 !important;
        padding: 0 1.5rem !important;
        width: 100% !important;
        box-sizing: border-box !important;
    }

    /* ✅ Hacer la tabla completamente responsiva */
    .tabla-con-controles {
        margin: 0 !important;
        width: 100% !important;
        max-width: 100% !important;
        overflow-x: auto !important;
    }

    /* ✅ Anchos fijos más agresivos para evitar desbordamiento */
    .tabla-unidadesConAlertas-custom >>> td:first-child,
    .tabla-unidadesConAlertas-custom >>> th:first-child {
        width: 40px; /* # - Más compacto */
        min-width: 40px;
        max-width: 40px;
        text-align: center;
    }

    .tabla-unidadesConAlertas-custom >>> td:nth-child(2),
    .tabla-unidadesConAlertas-custom >>> th:nth-child(2) {
        width: 110px; /* CBI - Reducido */
        min-width: 110px;
        max-width: 110px;
    }

    .tabla-unidadesConAlertas-custom >>> td:nth-child(3),
    .tabla-unidadesConAlertas-custom >>> th:nth-child(3) {
        width: 180px; /* Ubicación - Controlado */
        min-width: 180px;
        max-width: 180px;
    }

    .tabla-unidadesConAlertas-custom >>> td:nth-child(4),
    .tabla-unidadesConAlertas-custom >>> th:nth-child(4) {
        width: 110px; /* Piso - Optimizado con salto de línea */
        min-width: 110px;
        max-width: 110px;
        text-align: center;
        font-size: 0.7rem !important;
        line-height: 1.1 !important;
        white-space: normal !important;
        word-wrap: break-word !important;
        vertical-align: middle;
    }

    .tabla-unidadesConAlertas-custom >>> td:nth-child(5),
    .tabla-unidadesConAlertas-custom >>> th:nth-child(5) {
        width: 75px; /* Tipo equipo - Ampliado con salto de línea */
        min-width: 75px;
        max-width: 75px;
        white-space: normal !important;
        word-wrap: break-word !important;
        line-height: 1.1 !important;
        font-size: 0.7rem !important;
        text-align: center;
        vertical-align: middle;
    }

    .tabla-unidadesConAlertas-custom >>> td:nth-child(6),
    .tabla-unidadesConAlertas-custom >>> th:nth-child(6) {
        width: 75px; /* Marca - Ampliado para mostrar 'BlueLine' completo */
        min-width: 75px;
        max-width: 75px;
        font-size: 0.75rem !important;
    }

    .tabla-unidadesConAlertas-custom >>> td:nth-child(7),
    .tabla-unidadesConAlertas-custom >>> th:nth-child(7) {
        width: 70px; /* Capacidad - Reducido para compensar MARCA */
        min-width: 70px;
        max-width: 70px;
        text-align: center;
        font-size: 0.75rem !important;
    }

    .tabla-unidadesConAlertas-custom >>> td:nth-child(8),
    .tabla-unidadesConAlertas-custom >>> th:nth-child(8) {
        width: 100px; /* ON/OFF - Ligeramente reducido para compensar MARCA */
        min-width: 100px;
        max-width: 100px;
        text-align: center;
        font-size: 0.75rem !important;
    }

    .tabla-unidadesConAlertas-custom >>> td:nth-child(9),
    .tabla-unidadesConAlertas-custom >>> th:nth-child(9) {
        width: 50px; /* Estado - Más compacto para compensar ON/OFF */
        min-width: 50px;
        max-width: 50px;
        text-align: center;
    }

    .tabla-unidadesConAlertas-custom >>> td:last-child,
    .tabla-unidadesConAlertas-custom >>> th:last-child {
        width: 120px; /* Acciones - Ampliado para más botones */
        min-width: 120px;
        max-width: 120px;
        text-align: center;
    }

    .numero-fila {
        font-weight: 600;
        color: #4a5568;
        background-color: #e2e8f0;
        padding: 0.2rem 0.4rem; /* ✅ Más compacto */
        border-radius: 4px;
        min-width: 25px; /* ✅ Ancho mínimo reducido */
        display: inline-block;
        text-align: center;
        font-size: 0.8rem; /* ✅ Fuente más pequeña */
    }

    .contenedor-info {
        min-height: calc(100vh - 100px); 
        max-height: calc(100vh - 100px);
        padding: 1rem 0.5rem; /* ✅ Ajustado para balance entre espacio y contención */
        display: flex;
        flex-direction: column;
        overflow: hidden;
        width: 100%;
        box-sizing: border-box; /* ✅ Asegurar que padding esté incluido en el ancho */
    }

    .contenedor-info h4, .contenedor-info h6 {
        padding-left: 0.5rem; /* ✅ Reducido padding para más espacio horizontal */
        margin-bottom: 1rem;
        flex-shrink: 0;
    }

    /* Estilos mejorados para los títulos de ubicación */
    .titulos-ubicacion {
        padding: 0.5rem 0.5rem; /* ✅ Reducido padding horizontal para más espacio en tabla */
        margin-bottom: 0.75rem; /* ✅ Reducido de 1rem a 0.75rem */
        background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);
        border-radius: 8px; /* ✅ Reducido de 12px a 8px */
        box-shadow: 0 2px 10px rgba(74, 85, 104, 0.15); /* ✅ Reducido el shadow */
        position: relative;
        overflow: hidden;
        flex-shrink: 0;
    }
    
    .titulo-contenido {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
    
    .titulos-texto {
        flex: 1;
    }
    
    .boton-descarga-contenedor {
        display: flex;
        align-items: center;
        margin-left: 1rem;
    }
    
    .btn-descarga-bloque {
        background-color: rgba(255, 255, 255, 0.1) !important;
        border-color: rgba(255, 255, 255, 0.3) !important;
        color: white !important;
        font-weight: 600;
        font-size: 0.85rem;
        padding: 0.4rem 0.8rem;
        border-radius: 6px;
        transition: all 0.3s ease;
        backdrop-filter: blur(10px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    
    .btn-descarga-bloque:hover:not(:disabled) {
        background-color: rgba(255, 255, 255, 0.2) !important;
        border-color: rgba(255, 255, 255, 0.5) !important;
        color: white !important;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
    
    .btn-descarga-bloque:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
    
    .btn-descarga-bloque i {
        font-size: 0.9rem;
    }

    .titulos-ubicacion::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 2px; /* ✅ Reducido de 3px a 2px */
        background: linear-gradient(90deg, #63b3ed, #4299e1, #3182ce);
    }

    .titulo-sede {
        color: white !important;
        font-size: 1.5rem; /* ✅ Reducido de 1.75rem a 1.5rem */
        font-weight: 700;
        margin: 0 0 0.25rem 0 !important; /* ✅ Reducido de 0.5rem a 0.25rem */
        padding: 0 !important;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        letter-spacing: -0.025em;
        line-height: 1.2;
    }

    .titulo-bloque {
        color: #e2e8f0 !important;
        font-size: 0.9rem; /* ✅ Reducido de 1.1rem a 0.9rem */
        font-weight: 500;
        margin: 0 !important;
        padding: 0 !important;
        opacity: 0.9;
        letter-spacing: 0.025em;
        text-transform: uppercase;
        font-size: 0.85rem; /* ✅ Reducido de 0.95rem a 0.85rem */
    }

    /* Estilos para la paginación */
    .custom-pagination {
        margin: 0;
    }

    .custom-pagination >>> .page-link {
        border-radius: 6px;
        margin: 0 2px;
        border: 1px solid #dee2e6;
        color: #4a5568;
        padding: 0.35rem 0.6rem; /* ✅ Reducido de 0.5rem 0.75rem a 0.35rem 0.6rem */
        font-weight: 500;
        min-width: 36px; /* ✅ Reducido de 40px a 36px */
        text-align: center;
        font-size: 0.85rem; /* ✅ Agregado para reducir tamaño de fuente */
    }

    .custom-pagination >>> .page-link:hover {
        background-color: #e9ecef;
        border-color: #4a5568;
        color: #2d3748;
    }

    .custom-pagination >>> .page-item.active .page-link {
        background-color: #4a5568;
        border-color: #4a5568;
        color: white;
        font-weight: 600;
    }

    .custom-pagination >>> .page-item.disabled .page-link {
        opacity: 0.5;
        pointer-events: none;
    }

    /* ✅ Estilos para paginación durante carga */
    .pagination-loading {
        opacity: 0.6;
        pointer-events: none;
        transition: opacity 0.3s ease;
    }

    .pagination-loading >>> .page-link {
        cursor: not-allowed !important;
    }

    /* Asegurar que el contenido no se desborde y sea scrolleable */
    .tabla-unidadesConAlertas-custom >>> table {
        margin-bottom: 0;
        /* ✅ Forzar layout fijo para controlar anchos */
        border-collapse: collapse;
        width: 100%;
        table-layout: fixed; /* ✅ CRÍTICO: Layout fijo para controlar anchos */
        max-width: 100%;
        box-sizing: border-box;
    }

    /* ✅ Asegurar que las celdas no tengan padding excesivo */
    .tabla-unidadesConAlertas-custom >>> table td,
    .tabla-unidadesConAlertas-custom >>> table th {
        padding: 0.375rem 0.75rem; /* Bootstrap default pero controlado */
        vertical-align: middle;
    }

    /* Flexbox para controlar mejor la distribución del espacio */
    .contenedor-info > div:not(.texto-centro) {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
    }

    /* Asegurar que el titulo no tome espacio innecesario */
    .contenedor-info h4, 
    .contenedor-info h6 {
        flex-shrink: 0;
        margin-bottom: 0.5rem;
    }

    /* ✅ Estilos para el buscador */
    .buscador-container {
        margin-bottom: 1rem;
        padding: 0 1rem;
    }

    .input-group {
        max-width: 400px;
        margin: 0 auto;
    }

    .input-group-text {
        background-color: #f8f9fa;
        border-color: #ced4da;
        color: #6c757d;
    }

    .form-control-busqueda {
        border-color: #ced4da;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .form-control-busqueda:focus {
        border-color: #4a5568;
        box-shadow: 0 0 0 0.2rem rgba(74, 85, 104, 0.25);
    }

    .btn-limpiar {
        border-color: #ced4da;
        color: #6c757d;
        padding: 0.25rem 0.5rem;
    }

    .btn-limpiar:hover {
        background-color: #e9ecef;
        border-color: #adb5bd;
        color: #495057;
    }

    .resultados-busqueda {
        text-align: center;
        margin-top: 0.5rem;
    }

    /* ✅ Estilos para tabla con scroll vertical */
    .tabla-scrollable {
        max-height: 60vh; /* Altura máxima del 60% del viewport */
        overflow-y: auto;
        overflow-x: auto;
        border: 1px solid #dee2e6;
        border-radius: 8px;
    }

    /* ✅ Mantener header fijo mientras se hace scroll */
    .tabla-scrollable .table {
        margin-bottom: 0;
    }

    .tabla-scrollable .table thead th {
        position: sticky;
        top: 0;
        z-index: 10;
        background-color: #4a5568 !important;
        border-bottom: 2px solid #2d3748;
    }

    /* ✅ Asegurar que el scroll sea suave */
    .tabla-scrollable {
        scrollbar-width: thin;
        scrollbar-color: #cbd5e0 #f7fafc;
    }

    .tabla-scrollable::-webkit-scrollbar {
        width: 8px;
        height: 8px;
    }

    .tabla-scrollable::-webkit-scrollbar-track {
        background: #f7fafc;
        border-radius: 4px;
    }

    .tabla-scrollable::-webkit-scrollbar-thumb {
        background: #cbd5e0;
        border-radius: 4px;
    }

    .tabla-scrollable::-webkit-scrollbar-thumb:hover {
        background: #a0aec0;
    }

    /* ✅ Ajustar controles inferiores para mejor espaciado */
    .controles-inferiores {
        justify-content: space-between;
        align-items: center;
        padding: 0.75rem 1rem;
    }

    .conteo-registros {
        flex: 1;
        text-align: center;
    }

    .texto-conteo {
        font-size: 0.9rem;
        color: #4a5568;
        font-weight: 600;
    }

    /* ✅ Estilos específicos para filas con estado_id = 2 */
    .tabla-unidadesConAlertas-custom >>> tbody tr.row-danger {
        background-color: #f8d7da !important;
        color: #721c24 !important;
        border-color: #f5c6cb !important;
    }

    .tabla-unidadesConAlertas-custom >>> tbody tr.row-danger:hover {
        background-color: #f1b0b7 !important;
        color: #491217 !important;
    }

    .tabla-unidadesConAlertas-custom >>> tbody tr.row-danger td {
        color: #721c24 !important;
        border-color: #f5c6cb !important;
    }

    .tabla-unidadesConAlertas-custom >>> tbody tr.row-danger:nth-child(even) {
        background-color: #f8d7da !important;
    }

    /* ✅ Estilos para modal amplio de SweetAlert */
    :global(.swal-wide) {
        width: 600px !important;
        max-width: 90vw !important;
    }

    :global(.swal-wide .swal2-html-container) {
        text-align: left !important;
    }

    :global(.swal-wide ul) {
        text-align: left;
        margin: 10px 0;
    }

    :global(.swal-wide li) {
        margin: 5px 0;
    }

    /* Responsive para los títulos */
    @media (max-width: 768px) {
        .contenedor-info {
            margin: 0 0.25rem !important;
            padding: 0.5rem 0.75rem !important;
            width: calc(100% - 0.5rem) !important;
        }
        
        .titulos-ubicacion {
            padding: 0 1rem !important;
            margin-bottom: 0.75rem !important;
        }
        
        .tabla-con-controles {
            margin: 0 !important;
            width: 100% !important;
        }

        .buscador-container {
            padding: 0 0.5rem;
        }

        .input-group {
            max-width: 100%;
        }
        
        .tabla-scrollable {
            max-height: 50vh;
        }

        .titulo-sede {
            font-size: 1.3rem; /* ✅ Reducido de 1.5rem a 1.3rem */
        }

        .titulo-bloque {
            font-size: 0.75rem; /* ✅ Reducido de 0.85rem a 0.75rem */
        }
        
        .titulo-contenido {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.5rem;
        }
        
        .boton-descarga-contenedor {
            margin-left: 0;
            align-self: flex-end;
        }
        
        .btn-descarga-bloque {
            font-size: 0.8rem;
            padding: 0.3rem 0.6rem;
        }
        
        .controles-inferiores {
            padding: 0.4rem 0.75rem; /* ✅ Reducido proporcionalmente */
        }
    }

    @media (max-width: 480px) {
        .titulos-ubicacion {
            padding: 0.3rem 0.5rem; /* ✅ Ajustado proporcionalmente */
        }

        .titulo-sede {
            font-size: 1.2rem; /* ✅ Reducido de 1.3rem a 1.2rem */
        }

        .titulo-bloque {
            font-size: 0.7rem; /* ✅ Reducido de 0.8rem a 0.7rem */
        }
        
        .btn-descarga-bloque {
            font-size: 0.75rem;
            padding: 0.25rem 0.5rem;
        }
        
        .btn-descarga-bloque i {
            font-size: 0.8rem;
        }
        
        .controles-inferiores {
            padding: 0.3rem 0.5rem; /* ✅ Reducido proporcionalmente */
        }

        .buscador-container {
            padding: 0 0.25rem;
            margin-bottom: 0.75rem;
        }

        .tabla-scrollable {
            max-height: 45vh;
        }
    }
</style>